import { render, staticRenderFns } from "./SubjectsFilter.vue?vue&type=template&id=19220387&"
import script from "./SubjectsFilter.vue?vue&type=script&lang=js&"
export * from "./SubjectsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports